export interface Testimonial {
  text: string;
  name: string;
  role: string;
}

export const testimonials: Testimonial[] = [
  {
    text: 'Compré Balonmano Pro 360 un domingo por la noche. El martes entré a la pista con la sesión exacta planificada. Los chavales lo notaron desde el primer ejercicio. Espectacular.',
    name: 'Carlos M.',
    role: 'Entrenador Infantil · Balonmano Alcobendas'
  },
  {
    text: 'Pensé que era otro PDF teórico más. Pero esto es diferente. Las correcciones clave de cada ejercicio son oro puro. Nadie te enseña eso en los cursillos de entrenadores.',
    name: 'Raquel F.',
    role: 'Entrenadora Alevín · Madrid'
  },
  {
    text: 'Trabajo de lunes a viernes y entreno los fines de semana. Este sistema me ha devuelto los domingos. Ya no planifico desde cero. Solo ejecuto.',
    name: 'Laura G.',
    role: 'Coordinadora de Balonmano Base · Zaragoza'
  },
  {
    text: 'Al principio me pareció demasiado barato para ser bueno. Me equivoqué. La calidad del contenido está muy por encima del precio.',
    name: 'Iñaki A.',
    role: 'Director Técnico · Club Balonmano Bidasoa'
  },
  {
    text: 'Llevo el PDF en el móvil y lo consulto en el banquillo sin que nadie lo note. Es como tener un segundo entrenador al lado.',
    name: 'Pablo C.',
    role: 'Entrenador Cadete · Murcia'
  },
  {
    text: 'El Tomo 6 de gestión de padres me ha salvado la temporada. La reunión inicial con el guion que dan ahí eliminó el 90% de los problemas.',
    name: 'Marta R.',
    role: 'Entrenadora Juvenil · Sevilla'
  }
];
